"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardAvoidingView = void 0;
const React = require("react");
const react_native_1 = require("react-native");
class KeyboardAvoidingView extends React.Component {
    constructor() {
        super(...arguments);
        this.scrollViewRef = React.createRef();
        this.state = {
            keyboardHeight: 0
        };
        this.handleKeyboardShow = (event) => {
            const keyboardHeight = event.endCoordinates.height;
            const keyboardPosition = event.endCoordinates.screenY;
            this.setState({
                keyboardHeight
            });
            const scrollView = this.scrollViewRef.current;
            if (!scrollView) {
                return;
            }
            //@ts-ignore
            const currentlyFocusedInput = react_native_1.TextInput.State.currentlyFocusedInput();
            if (!currentlyFocusedInput) {
                return;
            }
            const { extraFieldHeight, extraWindowHeight } = this.props;
            const currentlyFocusedInputNode = (0, react_native_1.findNodeHandle)(currentlyFocusedInput);
            // @ts-ignore: no types :(
            react_native_1.UIManager.viewIsDescendantOf(currentlyFocusedInputNode, (0, react_native_1.findNodeHandle)(scrollView), (isDescendant) => {
                if (!isDescendant) {
                    return;
                }
                currentlyFocusedInput.measure((x, y, width, height, pageX, pageY) => {
                    const fieldPosition = pageY + height + extraFieldHeight;
                    if (fieldPosition <= keyboardPosition) {
                        return;
                    }
                    scrollView.scrollResponderScrollNativeHandleToKeyboard(currentlyFocusedInputNode, extraWindowHeight + extraFieldHeight, true);
                });
            });
        };
        this.handleKeyboardHide = () => {
            this.setState({
                keyboardHeight: 0
            });
        };
        this.scrollTo = (x, y) => {
            if (!this.scrollViewRef.current) {
                return;
            }
            this.scrollViewRef.current.scrollTo({ x, y });
        };
        this.scrollToEnd = () => {
            if (!this.scrollViewRef.current) {
                return;
            }
            this.scrollViewRef.current.scrollToEnd();
        };
    }
    componentDidMount() {
        // Android doesn't have 'will' events, but we can use 'did' there without any problem
        // iOS on the other hand needs to use the 'will' events otherwise the screen would show some empty spaces during keyboard events
        this.keyboardDidShowSubscription = react_native_1.Keyboard.addListener(react_native_1.Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow', this.handleKeyboardShow);
        this.keyboardDidHideSubscription = react_native_1.Keyboard.addListener(react_native_1.Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide', this.handleKeyboardHide);
    }
    componentWillUnmount() {
        this.keyboardDidShowSubscription.remove();
        this.keyboardDidHideSubscription.remove();
    }
    render() {
        const { refreshControl, scrollEnabled, onScroll, children, keyBoardShow } = this.props;
        // Android devices with notch will report less `availableHeight` than it should
        // That's because of this: https://github.com/facebook/react-native/issues/23693
        // If I change it to 'screen', Android devices with virtual buttons will report more than it should
        const availableHeight = react_native_1.Dimensions.get('window').height -
            this.state.keyboardHeight -
            this.props.extraWindowHeight;
        return (React.createElement(react_native_1.View, { style: [{ height: availableHeight }, !keyBoardShow && { flex: 1 }] },
            React.createElement(react_native_1.ScrollView, { ref: this.scrollViewRef, 
                // @ts-ignore: O react-native não tem auto, mas o react-native-web aceita
                refreshControl: refreshControl, scrollEnabled: scrollEnabled, onScroll: (e) => {
                    if (onScroll) {
                        onScroll(e.nativeEvent);
                    }
                }, scrollEventThrottle: 16 }, children({ availableHeight }))));
    }
}
exports.KeyboardAvoidingView = KeyboardAvoidingView;
KeyboardAvoidingView.defaultProps = {
    extraFieldHeight: 0,
    extraWindowHeight: 0,
    scrollEnabled: true
};
